import { motion } from "motion/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice.ts";
import CarouselSlider from "@/shared/widgets/CarouselSlider";
import getDesignVariantImage from "@/domains/estate/helpers/getDesignVariantImage.ts";
import EstateBadge from "@/domains/estate/components/EstateBadge";

type Props = {
  uuid: string;
  name: string;
  images: string[];
  price: number;
  isActive: boolean;
};

export default function EstateDesignVariantView({ uuid, price, name, images, isActive }: Props) {
  const { t } = useTranslation("estate");

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <motion.div
      initial={{ opacity: 0, translateX: "100%" }}
      animate={{ opacity: 1, translateX: "none" }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="flex flex-col w-full h-full gap-5"
    >
      <CarouselSlider
        src={getDesignVariantImage(uuid, images[activeIndex])}
        list={images}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        classNameContainer="h-[20rem]"
        classNameLeftBtn="top-auto left-5 bottom-5 -translate-y-[0%]"
        classNameRightBtn="top-auto right-5 bottom-5 -translate-y-[0%]"
        isHideButtons={images.length < 2}
      >
        {isActive && (
          <EstateBadge
            name="checked"
            text={t("estate.purchased")}
            className="absolute top-5 left-5 w-[6.4375rem] bg-[linear-gradient(90deg,rgba(33,101,44,0.3)_0%,rgba(18,18,18,0)_100%)] bg-[rgba(18,18,18,0.4)]"
            classNameIcon="w-3.5 h-2.5 bg-[#84FF97]"
            classNameText="text-12"
          />
        )}
      </CarouselSlider>
      <div>
        <div className="text-16 font-medium text-white">{t("estate.design.description")}:</div>
        <div className="mt-2.5 text-15 font-medium text-white/50 ">
          {t(`estate.design.designVariants.${name}.description`)}
        </div>
      </div>
      <div className="mt-auto">
        <div className="text-20 text-[#FF4E4E] font-bold text-left">{formatPrice(price)} ₽</div>
        <div className="text-15 text-white/50 font-medium mt-1.5 text-left">
          {t("estate.design.purchasePrice")}
        </div>
      </div>
    </motion.div>
  );
}
